export interface SalesDespatchNoteSearch {
  search: string;
  includeAll: boolean;
}
